import React from 'react';
import styles from './ParticipantListItem.module.scss';
import ListItem, { ListItemContent } from '../ListItem';
import UserName from '../UserName';
import UserAvatar from '../icons/UserAvatar';
import ParticipantPresenceIcon from './ParticipantPresenceIcon';

/**
 * A list item representing a participant in an event.
 *
 * @param {Object} props
 * @param {string} [props.className] - Additional CSS class name.
 * @param {Object} props.participant - Participant object.
 * @param {string} [props.tagName] - Tag name of the root element.
 * @param {*} props.children - List item content.
 * @param {*} props.rightContent - Content to be placed on the right side of the list item.
 * @param {string} [props.href] - Link href.
 * @param {function} [props.onAvatarClick] - Callback when the user avatar is clicked.
 * @param {function} [props.onClick] - Callback when the list item is clicked.
 * @param {boolean} [props.showUserDetails=true] - Whether to show the user details.
 * @param {boolean} [props.showPresence=true] - Whether to show the user presence icon.
 */
function ParticipantListItem(props) {
    const { className = '', participant, tagName, children, rightContent, href, onAvatarClick, onClick, showUserDetails, showPresence , large} = props;

    return (
        <ListItem className={[styles.ParticipantListItem, className, large ? styles.large : ''].join(' ')} tagName={tagName}>
            <UserAvatar user={participant} className={[styles.avatar, onAvatarClick ? 'clickable' : ''].join(' ')} onAvatarClick={onAvatarClick} showStatus />
            <ListItemContent href={href} onClick={onClick}>
                <div className="username text name">
                    <UserName user={participant} />
                </div>
                {showUserDetails ? (
                    <>
                        <div className="position">{participant.position}</div>
                        <div className="company">{participant.company}</div>
                    </>
                ) : null}
                {children}
            </ListItemContent>
            {showPresence ? <ParticipantPresenceIcon className={styles.presence} participant={participant} /> : null}
            {rightContent}
        </ListItem>
    );
}

export default ParticipantListItem;
